<template>
  <section class="container">
    <div class="btn_box">
      <div>
        <div class="my_car" @click="GoJump(1)">
          <div class="my_car__hb">
            <div class="header header1">
              <div class="header__unavailable">
              </div>
            </div>
          </div>
        </div>
        <div class="my_car" @click="GoJump(2)">
          <div class="my_car__hb">
            <div class="header header2">
              <div class="header__unavailable">
              </div>

            </div>
          </div>
        </div>
        <div class="my_car" @click="GoJump(3)">
          <div class="my_car__hb">
            <div class="header header3">
              <div class="header__unavailable">
              </div>
            </div>
          </div>
        </div>
        <div class="my_car" @click="GoJump(4)">
          <div class="my_car__hb">
            <div class="header header4">
              <div class="header__unavailable">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import noData from '@/assets/payment-related/noData@2x.png'

import { DatetimePicker, Divider, Field, Toast, Picker, Popup, Tab, Tabs, Row, Col, Icon, NoticeBar } from 'vant'
import { decrypt } from '@/api/user'
import { getRecord } from '@/api/park'
import { insertOrder } from '@/api/reserve'
import { getUrlParam } from '@/utils'
import { parseTime } from '@/utils'
import {
  getLocalStorage
} from "@/utils/auth";
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Reserve-Parking',
  components: {
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Divider.name]: Divider,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Picker.name]: Picker,  },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: [],
      columns: [],
      list: [],
      park: null,
      time: null, result_icon: noData,
      active: 1,
      phone: null,
      showTimePicker: false,
      showPicker: false,
      minDate: new Date(),
      currentDate: new Date(),
      listQuery: {
        //过滤参数
        page: 1,
        limit: 9999999,
      },
      params: {
        pickerTime: 1,
        parkId: 0,
        outTradeNo: null,
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString('zh')).getTime() - 30 * 24 * 60 * 60 * 1000
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString('zh')).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token', 'jntcImg', 'imgBtn', 'CJ_Phone'])
  },
  mounted () {
    let _this = this
    _this.handleRefresh()
    if (getUrlParam("phone")) {
      let params = {
        phone: getUrlParam("phone")
      }
      decrypt(params).then(res => {
        _this.$store.dispatch('SetPhone', res.body.phone)
        _this.phone = res.body.phone
        let listparams = {
          wxOpenid: _this.phone,
          startTime: _this.params.startDate[0],
          endTime: _this.params.startDate[1],
          startPage: _this.listQuery.page,
          pageSize: _this.listQuery.limit,
          parkId: 670,
          // outTradeNo: _this.params.outTradeNo,
          isInvoice: 0,
        }
        getRecord(listparams).then(ress => {
          this.list = ress.body.data
        })
      })
    } else {
      let listparams = {
        wxOpenid: _this.CJ_Phone,
        startTime: _this.params.startDate[0],
        endTime: _this.params.startDate[1],
        startPage: _this.listQuery.page,
        pageSize: _this.listQuery.limit,
        parkId: 670,
        // outTradeNo: _this.params.outTradeNo,
        isInvoice: 0,
      }
      getRecord(listparams).then(ress => {
        this.list = ress.body.data
      })
    }



  },
  methods: {
    GoJump (val) {

      this.$router.push({
        name: 'Reserve-Parking-List',
        query: { type: val }
      })
    },
    handleRefresh () {
      let params = {
        vehicleType: 1 //停车场类型
      }
      // queryPark(params).then(res => {
      //   this.columns = res.body
      // }).catch(err => {
      //   this.$toast(err)
      // })
    },
    chosenTime (res) {
      console.log(res)
      this.time = parseTime(new Date(res))
      this.showTimePicker = false
    },
    formatter (type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    onConfirm (res) {
      this.park = res
      this.showPicker = false
    },
    change (val) {
      this.plateNumber = val
    },
    submit () {

      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      if (!this.park) {
        _this.$toast('请选择停车场！')
        return
      } else if (!this.time) {
        _this.$toast('请选择预约时间！')
        return
      }
      let params = {
        parkid: this.park.parkId,
        platenumber: _this.plateNumber.join(''),
        starttime: parseTime(new Date(this.time)),
        endtime: parseTime(new Date(this.time).getTime() + 24 * 60 * 60 * 1000 - 1)
      }
      insertOrder(params).then(res => {
        if (res.status == 1001) {
          // this.$store.commit('transaction/SET_BILL_PARAMS', params)
          this.$router.push({
            name: 'Reserve-Result',
          })
          this.$toast.success('预约成功')

        } else {
          this.$toast(res.message)
        }
      }).catch(err => {
        this.$toast(err)
      })

    }
  },

}
</script>

<style lang="scss" scoped>
.container {
  .my_car {
    &__hb {
      padding: 5px 6.85vw 5px;
      .header1 {
        background: url(../../assets/BlpCardbg6.png);
      }
      .header2 {
        background: url(../../assets/BlpCardbg7.png);
      }
      .header3 {
        background: url(../../assets/BlpCardbg8.png);
      }
      .header4 {
        background: url(../../assets/BlpCardbg9.png);
      }
      .header {
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        width: 100%;
        min-height: 140px;

        &__untied-btn {
          height: 80%;
          width: 33%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;

          /deep/ .van-button--plain {
            background-color: rgba(0, 0, 0, 0);
          }
        }

        &__unavailable {
          width: 100%;
          position: relative;
          &__title {
            padding-top: 25px;
            display: block;
            color: #fff;
            text-align: left;
            font-size: 24px;
            padding-left: 20px;
            font-weight: 500;
          }

          &__content {
            padding-top: 35px;
            padding-left: 20px;
            text-align: left;
            display: block;
            font-weight: 400;
            font-size: 16px;
            color: #eaf4ff;
          }
          &__btn {
            position: absolute;
            bottom: 10px;
            right: 10px;
            padding: 10px;
          }
        }
      }
    }
  }
  .noData_container {
    height: calc(100vh - 50px);

    .result_content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      flex-wrap: nowrap;
      height: px2rem(275);
      text-align: center;

      .result_icon {
        width: px2rem(120);
        height: auto;
        margin: 0 auto 20px;
      }

      .result_title {
        height: px2rem(40);
        line-height: px2rem(40);
        font-size: px2rem(22);
      }
    }

    .button_box {
      padding: 0 10px 0;
    }
  }
  .order {
    background: #ffffff;
    margin-bottom: 10px;
    border-radius: 5px;
    box-shadow: #a5a5a5 3px 3px 5px;
    margin: 10px;

    &__icon {
      font-size: 20px;
      color: #4b62ec;
      line-height: 24px;
      margin-right: 8px;
      height: 24px;
    }

    &__id {
      color: #444444;
      font-size: 16px;
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f5;
      background: #fff;
    }

    /deep/ .van-cell__title {
      color: #444444;

      .order__info {
        font-size: 16px;
        // text-align: right;
      }

      .order__money {
        font-size: 18px;
        color: #49a6ff;
      }
    }
  }
  .btn_box {
    // padding: 0 15px;
  }
}
</style>